export default __webpack_public_path__ + "static/media/Eye_6_F_C5.08671dd8.svg";